// Almacenamiento LOCAL de fotos de ortodoncia (IndexedDB en el equipo del médico).
// Las fotos NO se suben a la nube: viven solo en este navegador/PC.
const DB_NAME = "clinped_ortho_photos";
const STORE = "photos";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const os = db.createObjectStore(STORE, { keyPath: "key" });
        os.createIndex("patient_id", "patient_id", { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

const photoKey = (patientId, visitId, slot) => `${patientId}:${visitId}:${slot}`;

export async function savePhoto(patientId, visitId, slot, dataUrl) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put({ key: photoKey(patientId, visitId, slot), patient_id: patientId, visit_id: visitId, slot, dataUrl, saved_at: Date.now() });
    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
}

export async function getPhoto(patientId, visitId, slot) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const req = db.transaction(STORE, "readonly").objectStore(STORE).get(photoKey(patientId, visitId, slot));
    req.onsuccess = () => resolve(req.result?.dataUrl || null);
    req.onerror = () => reject(req.error);
  });
}

export async function deletePhoto(patientId, visitId, slot) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(photoKey(patientId, visitId, slot));
    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
}

export async function deleteVisitPhotos(patientId, visitId) {
  await Promise.all(["before", "after"].map((s) => deletePhoto(patientId, visitId, s).catch(() => {})));
}

// Comprime una imagen a dataURL JPEG (máx 1400px) antes de guardarla en IndexedDB.
export function fileToCompressedDataUrl(file, maxSide = 1400, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxSide || height > maxSide) {
          const scale = maxSide / Math.max(width, height);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width; canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
